'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_TwoFactorAuthView$$anon$36() {
  this.bC4 = null;
  this.bC5 = false;
}
export { $c_Lpresto_TwoFactorAuthView$$anon$36 as $c_Lpresto_TwoFactorAuthView$$anon$36 };
$p = $c_Lpresto_TwoFactorAuthView$$anon$36.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_TwoFactorAuthView$$anon$36;
/** @constructor */
function $h_Lpresto_TwoFactorAuthView$$anon$36() {
}
export { $h_Lpresto_TwoFactorAuthView$$anon$36 as $h_Lpresto_TwoFactorAuthView$$anon$36 };
$h_Lpresto_TwoFactorAuthView$$anon$36.prototype = $p;
$p.P = (function() {
  if ((!this.bC5)) {
    this.bC4 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_T8($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_None$(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_None$(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_None$(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_None$(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_None$(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_None$(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_None$(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_Some($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_None$()));
    this.bC5 = true;
  }
  return this.bC4;
});
var $d_Lpresto_TwoFactorAuthView$$anon$36 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_TwoFactorAuthView$$anon$36, "presto.TwoFactorAuthView$$anon$36", ({
  SU: 1,
  a: 1,
  i: 1
}));
export { $d_Lpresto_TwoFactorAuthView$$anon$36 as $d_Lpresto_TwoFactorAuthView$$anon$36 };
//# sourceMappingURL=presto.-Two-Factor-Auth-View$$anon$36.js.map
